import HistorianTableView from '@pages/HistorianTableView/index';
import { RouteObject } from 'react-router';

export default [
  {
    path: '/historian-tableview/:request',
    element: <HistorianTableView />,
  },
] as RouteObject[];
